import React from 'react'
import TourTemplate from '../index'

const feature = 'userPreference'

const steps = [
  {
    name: 'notificationConfig',
    target: '#notification-config',
    title: 'Configure Email Notification Preferences',
    content: "You can set the frequency at which you receive email notifications by clicking the 'Notification Preferences' link in the menu.",
    placement: 'bottom',
    audience: 'new',
  }
]

const PreferenceTour = () => (
  <TourTemplate
// @ts-expect-error - TS2322 - Type '{ name: string; target: string; title: string; content: string; placement: string; audience: string; }[]' is not assignable to type 'TourStep[]'.
    steps={steps}
    feature={feature}
  />
)

export default PreferenceTour
